export default __webpack_public_path__ + "static/media/lead-artur.53e0cef2.png";